module.exports = __webpack_public_path__ + "media/byleth.45ad0203.wav";